import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import useFloating from 'hooks/layers/useFloating';
import React from 'react';
import FocusableButton from './FocusableButton';
import HBox from './HBox';
import VBox from './VBox';

export default React.forwardRef(function DialogButton(props, outerRef) {
  const {
    id,
    label,
    tags,
    category,
    children,
    ...rest
  } = props || {};

  const ref = React.useRef(null);
  React.useImperativeHandle(outerRef, () => ref.current, []);

  const [list, setList] = Recoil.useRecoilState(AppStore.floatings.list(category));
  const [hash, setHash] = Recoil.useRecoilState(AppStore.floatings.hash(category));
  const {
    open,
    update,
    close,
  } = useFloating({ setList, setHash });

  const [active, setActive] = React.useState(false);
  const disactive = React.useCallback(() => {
    setActive(() => false);
  }, []);
  const onOuterClick = React.useCallback((ref) => (e) => {
    if (!ref?.current?.contains(e.target)) {
      close(id, disactive);
    }
  }, [close, disactive, id]);
  const onClose = React.useCallback((e) => {
    close(id, disactive);
  }, [close, disactive, id]);

  const onSubmit = React.useCallback((e) => {
    close(id, disactive);
  }, [close, disactive, id]);
  const onClick = React.useCallback(() => {
    setActive(() => true);
    open({
      id: id,
      reference: null,
      placement: 'screen-center',
      connection: 'none',
      width: 'auto',
      height: 'auto',
      veilable: true,
      stickable: true,
      movable: false,
      closable: false,
      escapable: false,
      modal: true,
      type: 'Dialog',
      tags,
      events: {
        onOuterClick,
        onClose,
        onSubmit,
      },
      props: {
        children,
      },
    });
  }, [open, id, tags, onOuterClick, onClose, onSubmit, children]);

  return (
    <FocusableButton
      {...ex(['DialogButton', { active }], rest)}
      {...{ ref, onClick }}
    >
      {label}
    </FocusableButton>
  );
});
